import { formatMoney } from '../lib/accounting';
import currencyFormatter from 'currency-formatter';
import { BUSINESS_EXTRA } from '../store/selectors/auth.selector';

export const getPoints = (points) => {
  return `${parseInt(points) / 1000}K`;
};

export const isBXcurrency = (currencyCulture) => {
  return currencyCulture === BUSINESS_EXTRA;
};
export function getCurrencySymbol(currencyCode) {
  return currencyFormatter.findCurrency(currencyCode);
}

export const formatCurrency = (fareDigits, currencyCode, currencyCulture, precision = 0) => {
  if (isBXcurrency(currencyCulture)) {
    return `${getPoints(fareDigits)} ${currencyCode}`;
  }
  const europeanCultures = ['br-FR', 'en-DE', 'fr-FR', 'it-IT', 'en-FR'];
  if (europeanCultures.includes(currencyCulture)) {
    return currencyFormatter.format(fareDigits, {
      code: currencyCode,
      precision: precision,
      format: '%v %s',
      thousand: '.',
    });
  } else if (currencyCulture === 'en-IE' && currencyCulture === 'EUR') {
    return currencyFormatter.format(fareDigits, {
      code: currencyCode,
      locale: currencyCulture,
      precision: precision,
    });
  } else if (currencyCulture === 'en-US' && currencyCode === 'EUR') {
    return currencyFormatter.format(fareDigits, {
      symbol: '€',
      code: currencyCode,
      locale: currencyCulture,
      precision: precision,
    });
  } else {
    return currencyFormatter.format(fareDigits, {
      code: currencyCode,
      precision: precision,
      locale: currencyCulture,
    });
  }
};

// export const formatCurrency = (number, currencyCode, round = 0) => {
//   console.log({ currencyCode });
//   const currency = {
//     USD: '$',
//     GBP: '£',
//     AUD: '$',
//     EUR: '€',
//     CAD: '$',
//     MIXED: '~',
//   };

//   let thousand = '',
//     decimal = ',',
//     format = '%s%v';

//   if (['USD', 'AUD', 'CAD', 'MIXED'].includes(currencyCode)) {
//     thousand = '';
//     decimal = '.';
//     format = '%s%v';
//   }

//   return formatMoney(number, currency[currencyCode], round, thousand, decimal, format);
// };

export const getCurrencySymbolForSeatMapFare = (fareDigits, currencyCode, currencyCulture) => {
  const CURRENCY_CODE = currencyCode;
  const CURRENCY_CULTURE = currencyCulture;
  const EUROPEAN_CULTURES = {
    // 'EUR': 'br-FR',
    // 'EUR': 'en-DE',
    EUR: 'fr-FR',
    // 'EUR': 'it-IT',
  };

  if (CURRENCY_CULTURE !== 'zh-HK' && CURRENCY_CODE === 'HKD') {
    return currencyFormatter.format(fareDigits, { symbol: '$', code: CURRENCY_CODE });
  } else if (CURRENCY_CODE === 'PEN') {
    return currencyFormatter.format(fareDigits, {
      symbol: 'S/',
      code: CURRENCY_CODE,
      locale: CURRENCY_CULTURE,
      format: '%s%v',
    });
  } else if (CURRENCY_CULTURE === 'es-MX') {
    return currencyFormatter.format(fareDigits, {
      code: CURRENCY_CODE,
      format: '%s%v',
      decimal: '.',
    });
  } else if (CURRENCY_CODE === 'CZK') {
    return currencyFormatter.format(fareDigits, {
      code: CURRENCY_CODE,
      format: '%v %s',
      thousand: '.',
    });
  } else if (EUROPEAN_CULTURES[CURRENCY_CODE]) {
    return currencyFormatter.format(fareDigits, {
      code: CURRENCY_CODE,
      format: '%v %s',
      thousand: '.',
    });
  } else if (CURRENCY_CULTURE === 'en-IE' && CURRENCY_CODE === 'EUR') {
    return currencyFormatter.format(fareDigits, { code: CURRENCY_CODE, locale: CURRENCY_CULTURE });
  } else if (CURRENCY_CULTURE === 'en-US' && CURRENCY_CODE === 'EUR') {
    return currencyFormatter.format(fareDigits, {
      symbol: '$',
      code: CURRENCY_CODE,
      locale: CURRENCY_CULTURE,
    });
  } else if (CURRENCY_CULTURE === 'en-US' && CURRENCY_CODE === 'INR') {
    return currencyFormatter.format(fareDigits, { symbol: '$', code: CURRENCY_CODE });
  } else if (CURRENCY_CODE === 'PLN') {
    return currencyFormatter.format(fareDigits, { code: CURRENCY_CODE, thousand: '.' });
  } else if (CURRENCY_CODE === 'ZAR') {
    return currencyFormatter.format(fareDigits, { code: CURRENCY_CODE, thousand: '.' });
  } else {
    return currencyFormatter.format(fareDigits, { code: CURRENCY_CODE });
  }
};
